"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "orero": {
    "19e36e4c": [{
      "hkey": "f9ba380a",
      "slug": "pian-dei-ratti-pianezza",
      "name": "Pian dei Ratti-Pianezza",
      "primary": true,
      "skipSearch": false
    }],
    "pian-dei-ratti": [{
      "hkey": "f9ba380a",
      "slug": "pian-dei-ratti-pianezza",
      "name": "Pian dei Ratti-Pianezza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "orero"
    }],
    "cdbf4d0e": [{
      "hkey": "f9ba380a",
      "slug": "pian-dei-ratti-pianezza",
      "name": "Pian dei Ratti-Pianezza",
      "primary": true,
      "skipSearch": false
    }],
    "pianezza": [{
      "hkey": "f9ba380a",
      "slug": "pian-dei-ratti-pianezza",
      "name": "Pian dei Ratti-Pianezza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "orero"
    }]
  }
};
exports["default"] = _default;